import image from './image-repository'

export default function images(basePath, imageId, poleInfo) {
  const imageRepository = imageId ? new image(`${basePath}/${imageId}`) : new image(`${basePath}`)
  return {
    getPoleAndImageList: imageRepository.getPoleAndImageList(poleInfo),
  }
}
